<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="close"><i class="fa fa-sliders"></i>&nbsp; Html to Video Render Options</modal-header>
    </div>
    <div class="modal-render-html-video">
      <p>
        Change the video render settings
      </p>
      <div>
        <hr/>
        <div class="form-group row">
          <label for="duration" class="col-sm-4 col-form-label">Define the video duration</label>
          <div class="col-sm-8">
            <input type="number" id="duration" value="8">
            <br/>
            <small>
              Define the number of seconds for the video duration according with the banner animation
              duration. (Use period to define decimal values. Ex: 7.20)
            </small>
          </div>
        </div>
        <div class="form-group row">
          <label for="fps" class="col-sm-4 col-form-label">Frames per second (FPS)</label>
          <div class="col-sm-8">
            <select id="fps" name="fps" class="modal-render-html-video__dropdown-fps">
              <option v-for="(value, key) in fpsOptions" :key="key" :value="key">{{ value }}</option>
            </select>
            <br/>
            <small>
              Select the number of frames per second. Higher is better.
            </small>
          </div>
        </div>
        <div class="form-group row">
          <label for="format" class="col-sm-4 col-form-label">Video Format</label>
          <div class="col-sm-8">
            <select id="format" name="fps" class="modal-render-html-video__dropdown-fps">
              <option v-for="(value, key) in videoFormats" :key="key" :value="key">{{ value }}</option>
            </select>
            <br/>
            <small>
              Select the format for the video.
            </small>
          </div>
        </div>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="() => null" cancelText="Cancel Render request" confirmText="Continue" confirmTheme="primary" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import {modalMixin} from '@/mixins/modalMixin'
import ModalFooter from '@/components/Modal/modal-footer'

export default {
  name: 'modal_render_html_video',
  mixins: [modalMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter
    // ButtonCta
  },
  props: {
    show: Boolean
  },
  data: () => ({}),
  mounted () {
  },
  computed: {
    fpsOptions () {
      return {
        15: 15,
        30: 30,
        60: 60,
        90: 90
      }
    },
    videoFormats () {
      return {
        mp4: 'MP4',
        gif: 'GIF'
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.modal-render-html-video {
  &__dropdown-fps {
    width: 44%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-render-html-video.vue